<script>
import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table } from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(RichTextEditorPlugin);

export default {
    name: "SickOffNote",

    data() {

        return {
            templates: [],
            templateID: 0,
            sickOffNote: {
                id: 0,
                patientID: this.$route.params.patientID,
                visitNo: this.$route.params.visitNo,
                encounterID: this.$route.query.encounterID,
                sickoffDate: window.moment().format(`YYYY-MM-DD`),
                userName: this.$root.username,
                cancelled: false,
                description: ``,
            },
        };
    },

    watch: {

        templateID() {
            if(!this.templateID) return;

            const templates = this.templates.filter(temp => temp.tempID == this.templateID);

            if(!templates.length) return;

            this.sickOffNote.description = templates[0].template;
        },
    },

    mounted() {

        Promise.allSettled([ this.fetchSickOffNote(), this.fetchTemplates(), ]);
    },

    methods: {

        fetchTemplates() {

            return this.$http.get(`MedicalFile/GetMedicalNotesTemplateNames`).then(response => {
                this.templates = response.data;
            }).catch(() => {});
        },

        fetchSickOffNote() {
            let url = `MedicalFile/GetPatientSickOffNotes`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNo}`;
            return this.$http.get(url)
                    .then(response => {
                        this.sickOffNote = response.data.length ? response.data[0] : {
                            id: 0,
                            patientID: this.$route.params.patientID,
                            visitNo: this.$route.params.visitNo,
                            encounterID: this.$route.query.encounterID,
                            sickoffDate: window.moment().format(`YYYY-MM-DD`),
                            userName: this.$root.username,
                            cancelled: false,
                            description: ``,
                        };
                    }).catch(() => {});
        },

        saveData() {
            this.$root.loading = true;
            this.$http.post(`MedicalFile/PatientSickOffNote`, this.sickOffNote).then(response => {
                this.$root.loading = false;
                window.Swal.fire({ text: response.data, type: `success`});
            }).catch(() => {
                this.$root.loading = false;
            });
        },

        printNote() {

            window.open(
            `/medical-file/sick-off-note-print/print/${this.$route.params.patientID}/${this.$route.params.visitNo}`, 
            '_blank', `PatientPreview`, 
            "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },

    provide: {

     richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table]
    },
}
</script>
<template>
<div class="w-full">
    <div class="md:w-1/4 sm:w-full p-tiny">
        <label for="grid-sick-off-template" class="label-control">Template</label>
        <v-select class="text-xs bg-white" :options="templates" :reduce="temp => temp.tempID" v-model="templateID" label="tempName"></v-select>
    </div>
    <div class="w-full p-tiny">
        <label for="sickoffnoteRTE" class="label-control">Notes:</label>
        <ejs-richtexteditor ref="sickoffnoteRTE" 
            v-model.trim="sickOffNote.description" 
            :toolbarSettings= "{
              items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
              'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
              'LowerCase', 'UpperCase', 'SuperScript', 'SubScript' , '|',
              'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
              'Outdent', 'Indent', '|',
              'CreateTable', 'CreateLink', 'Image', '|', 
              'ClearFormat', 'Print', 'SourceCode', 'FullScreen', '|', 
              'Undo', 'Redo']
          }"
        />
    </div>
    <div class="w-full p-tiny text-right">
        <button
            @click.prevent="printNote" 
            class="btn-sm btn-info text-xs rounded mr-6">
                <i class="fa fa-print"></i> Print</button>
        <button 
            class="btn-sm text-xs btn-primary rounded" 
            @click.prevent="saveData">
                <i class="fa fa-save"></i> Save</button>
    </div>
</div>
</template>
